import axios from "axios";

const baseURL = 'https://apiportalpagos.quac.co/api'
// const baseURL = 'https://apiportalpagos.devquac.com/api'
// const baseURL = 'http://192.168.208.208:7001/api'

const apiQuac = axios.create({
    baseURL
})

export default apiQuac